import { SettingsFavorite } from '../favorites';
import {
  creatorFilterAllOption,
  pageNameFilterAllOption,
  shareOptions,
} from './consistent';

export const filterFavorites = (
  favorites: SettingsFavorite | undefined,
  options: {
    shareFilter: (typeof shareOptions)[number];
    pageNameFilter: typeof pageNameFilterAllOption | string;
    creatorFilter: typeof creatorFilterAllOption | string;
  }
): SettingsFavorite | undefined => {
  const { shareFilter, pageNameFilter, creatorFilter } = options;

  if (favorites == null) {
    return;
  }

  if (favorites.favorites == null) {
    return favorites;
  }

  let filtered = favorites.favorites;

  // 共有フィルタ
  if (shareFilter !== 'すべて') {
    filtered = filtered.filter((favorite) => {
      switch (shareFilter) {
        case '全体共有':
          return favorite.isShared;
        case '一部共有':
          return (
            !favorite.isShared &&
            favorite.privatelySharedUsers &&
            favorite.privatelySharedUsers.length > 0
          );
        case '共有なし':
          return (
            !favorite.isShared &&
            (favorite.privatelySharedUsers == null ||
              favorite.privatelySharedUsers.length === 0)
          );
        default:
          throw new Error('Invalid share filter');
      }
    });
  }

  // 対象画面フィルタ
  if (pageNameFilter !== pageNameFilterAllOption) {
    filtered = filtered.filter(
      (favorite) => favorite.pageName === pageNameFilter
    );
  }

  // 作成者フィルタ
  if (creatorFilter !== creatorFilterAllOption) {
    filtered = filtered.filter(
      (favorite) => favorite.createdBy?.name === creatorFilter
    );
  }

  return {
    ...favorites,
    favorites: filtered,
  };
};
